module.exports = __webpack_public_path__ + "img/secretheart.8e24a0a.jpg";